export default {"slider":"HYy7p","arrow":"_8ycr7"};